import { CheckboxInput, FormItem } from '@framework/form';
import React from 'react';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

export interface IIntegerRuleComponentProps {}

const fieldName = `rules.${RuleType.Integer}`;

export function IntegerRuleComponent(props: IIntegerRuleComponentProps) {
  return (
    <FormItem
      name={`${fieldName}.value`}
      label={null}
      layout={{ removeMargin: true }}
    >
      <CheckboxInput name={`${fieldName}.value`} defaultChecked={false}>
        Solo numeri interi
      </CheckboxInput>
      <CustomValidationRuleMessage
        isGhostType
        name={`${fieldName}.customMessage`}
      />
    </FormItem>
  );
}
